function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export default function (offset) {
  if (!offset) {
    return undefined;
  }

  var offsetTop;
  var offsetRight;
  var offsetBottom;
  var offsetLeft;

  if (_typeof(offset) === 'object') {
    offsetTop = offset.top || 0;
    offsetRight = offset.right || 0;
    offsetBottom = offset.bottom || 0;
    offsetLeft = offset.left || 0;
  } else {
    offsetTop = offset || 0;
    offsetRight = offset || 0;
    offsetBottom = offset || 0;
    offsetLeft = offset || 0;
  }

  return {
    top: offsetTop,
    right: offsetRight,
    bottom: offsetBottom,
    left: offsetLeft
  };
}